"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_spring_1 = require("react-spring");
var react_color_1 = require("react-color");
var common_1 = require("react-color/lib/components/common");
var hooks_1 = require("../../hooks");
var Close_1 = __importDefault(require("../../icons/Close"));
var Pen_1 = __importDefault(require("../../icons/Pen"));
var theme_1 = __importDefault(require("../../theme"));
var styles_1 = require("./styles");
/**
 * Renders a color picker UI.
 * @param color Current selected color.
 * @param onChange Function that sets, based on users picked color, the selected color to pass it up to parent.
 */
function ColorPicker(props) {
    var _a = react_1.useState(false), showPicker = _a[0], setShowPicker = _a[1];
    var spring = react_spring_1.useTransition(showPicker, null, {
        delay: 2,
        from: { opacity: 0 },
        enter: { opacity: 1 },
        leave: { opacity: 0 },
    });
    var pickerDialogRef = react_1.useRef(null);
    hooks_1.useClickOutsideContainer(pickerDialogRef, function () {
        setShowPicker(false);
    });
    return (react_1.default.createElement(styles_1.MainContainer, null,
        react_1.default.createElement(styles_1.CurrentColorContainer, { color: props.color }),
        react_1.default.createElement("p", { style: { marginLeft: 10 } }, props.color),
        react_1.default.createElement(styles_1.PickerButtonContainer, null,
            react_1.default.createElement(styles_1.PickerButton, { onClick: function (event) {
                    event.preventDefault();
                    setShowPicker(!showPicker);
                } },
                react_1.default.createElement(Pen_1.default, { height: "22px" }))),
        spring.map(function (_a) {
            var item = _a.item, key = _a.key, _props = _a.props;
            return item ? (react_1.default.createElement(styles_1.PickerDialogBackdrop, { key: key, style: _props, "aria-modal": "true", role: "dialog" },
                react_1.default.createElement(styles_1.PickerDialog, { ref: pickerDialogRef },
                    react_1.default.createElement(styles_1.CloseIconContainer, { onClick: function () { return setShowPicker(false); } },
                        react_1.default.createElement(Close_1.default, { color: theme_1.default.colorsPalette.gray.light, height: "13px" })),
                    react_1.default.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                        react_1.default.createElement(styles_1.PickerDialogTitle, null, "Selecciona un color"),
                        react_1.default.createElement(styles_1.PickerSaturationContainer, null,
                            react_1.default.createElement(common_1.Saturation, __assign({}, props))),
                        react_1.default.createElement(styles_1.PickerHueContainer, null,
                            react_1.default.createElement(common_1.Hue, __assign({}, props, { direction: "horizontal" }))))))) : null;
        })));
}
exports.default = react_color_1.CustomPicker(ColorPicker);
//# sourceMappingURL=index.js.map